import CafeList from "./CafeList";
import CafeDetail from "./CafeDetail";
import PlaceDetail from "./PlaceDetail";

/**
 * 데스크탑 좌측 사이드 패널.
 * 모바일 BottomSheet 와 같은 컴포넌트(CafeList/CafeDetail/PlaceDetail)를 호스트.
 * 시트 드래그 없음 — 항상 420px 폭으로 펼침.
 *
 * 헤더:
 *   - 선택 없음: 로고
 *   - 카페/음식점 선택됨: ◀ + 공유
 *
 * 본문:
 *   - 음식점 선택 → PlaceDetail
 *   - 카페 선택   → CafeDetail
 *   - 그 외       → CafeList (전체 카페 목록)
 *
 * ◀ 클릭:
 *   - 음식점 상세 → 카페 상세 복귀 (onClosePlace)
 *   - 카페 상세   → 카페 리스트 복귀 (onCloseCafe)
 */
export default function SidePanel({
  cafe,
  place,
  visibleCafes,
  places,
  region,
  userLocation,
  userRegionName,
  selectedPlaceId,
  onSelectCafe,
  onSelectPlace,
  onCloseCafe,
  onClosePlace,
  onShare,
}) {
  const hasSelection = !!(cafe || place);
  const handleBack = place ? onClosePlace : onCloseCafe;

  return (
    <aside className="cf-sidepanel">
      <div className="cf-sidepanel__header">
        {hasSelection ? (
          <>
            <button
              className="cf-sheet__back"
              onClick={handleBack}
              aria-label="뒤로"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.2"
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>
            <div className="cf-sheet__topbar-spacer" />
            <button
              className="cf-sheet__share"
              onClick={onShare}
              aria-label="공유"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
              >
                <circle cx="18" cy="5" r="3" />
                <circle cx="6" cy="12" r="3" />
                <circle cx="18" cy="19" r="3" />
                <path d="M8.6 13.5l6.9 4M15.5 6.5l-6.9 4" />
              </svg>
            </button>
          </>
        ) : (
          <>
            <img
              src="/logo-wordmark-white.png"
              alt="커피파인더"
              className="cf-sidepanel__logo"
            />
            <div className="cf-sheet__topbar-spacer" />
            <a
              href="https://smore.im/form/pJFD2vQDtz"
              target="_blank"
              rel="noopener noreferrer"
              className="cf-header-action"
              aria-label="참여하기"
              title="참여하기"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="8" y="2" width="8" height="4" rx="1" />
                <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                <path d="M9 13l2 2 4-4" />
              </svg>
            </a>
          </>
        )}
      </div>

      <div className="cf-sidepanel__body">
        {place ? (
          <PlaceDetail
            place={place}
            fromCafe={cafe}
            userLocation={userLocation}
          />
        ) : cafe ? (
          <CafeDetail
            cafe={cafe}
            places={places}
            userLocation={userLocation}
            onSelectPlace={onSelectPlace}
            selectedPlaceId={selectedPlaceId}
          />
        ) : (
          <CafeList
            cafes={visibleCafes}
            places={places}
            region={region}
            userLocation={userLocation}
            userRegionName={userRegionName}
            onSelectCafe={onSelectCafe}
          />
        )}
      </div>
    </aside>
  );
}
